
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";

import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    CrossIconHover,
    FormWrapper,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: String, required: false })
  readonly email?: String;

  isHovered: boolean = false;
  updatedEmail: string = this.email ? this.email.toString() : "";

  closeModal(): void {
    this.$emit("close");
  }
  addEmail() {
      if (this.updatedEmail.length > 0) {
        this.$emit('edit-email', { oldName: this.email, newName: this.updatedEmail });
      } else {
        this.$emit('add-email', this.email);
      }
      this.$emit('close');
    }

    editEmail() {
        this.$emit('edit-email', {
        oldName: this.updatedEmail,
        newName: this.email
      });
      this.closeModal();
    }

}
